// extracted by mini-css-extract-plugin
module.exports = {"EledoTemplateRoot":"EledoTemplateRoot_EledoTemplateRoot__3StS9","content-wrapper":"EledoTemplateRoot_content-wrapper__QkPZr"};